import type { SelectItemData } from '.';

export const professionalLicenses: SelectItemData = [
  { value: 'MD', label: 'Doctor of Medicine' },
  { value: 'DO', label: 'Doctor of Osteopathic Medicine' },
  { value: 'PHD', label: 'Doctor of Philosophy' },
  { value: 'PSYD', label: 'Doctor of Psychology' },
  { value: 'NP', label: 'Nurse Practitioner' },
  { value: 'MFT', label: 'Marriage & Family Therapist' },
  { value: 'LCSW', label: 'Licensed Clinical Social Worker' },
  { value: 'LPC', label: 'Licensed Professional Counselor' },
];
